import { createStyles, rem } from "@mantine/core";


export const navbarStyles = createStyles((theme) => ({
    header: {
        backgroundColor: 'black',
        alignContent: 'center',
        borderBottom: '1px solid #27272a',
    },

    inner: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'none',
        // backgroundColor: 'black'
      },

    mobileHeader: {
        display: 'flex',
        flexDirection: 'col',
        backgroundColor: 'black',
        // alignContent: 'center',
        borderBottom: '1px solid #27272a',
        paddingLeft: '0',
        // justifyContent: 'between',
    },

    link: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        paddingLeft: theme.spacing.md,
        paddingRight: theme.spacing.md,
        textDecoration: 'none',
        color: '#71717a',
        fontWeight: 600,
        fontSize: theme.fontSizes.sm,
        textTransform: 'uppercase',
        letterSpacing: '0.025em',
        whiteSpace: 'nowrap',
        transition: 'color 200ms',

        [theme.fn.smallerThan('lg')]: {
            paddingLeft: theme.spacing.xs,
            paddingRight: theme.spacing.xs,
        },

        [theme.fn.smallerThan('sm')]: {
            height: rem(42),
            display: 'flex',
            alignItems: 'center',
            width: '100%',
        },

        ...theme.fn.hover({
            color: '#e4e4e7',
        }),
    },

    // Same as the selected tab in TextTabs. An inset shadow, so it doesn't change the height
    linkActive: {
        color: 'white',
        boxShadow: 'inset 0 -2px 0 white',

        ...theme.fn.hover({
            color: 'white',
        }),
    },

    socialLinks: {
        color: '#71717a',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'color 200ms',

        ...theme.fn.hover({
            color: '#e4e4e7',
        }),

    },

    subLink: {
        width: '100%',
        padding: `${theme.spacing.xs} ${theme.spacing.md}`,
        borderRadius: theme.radius.md,

        ...theme.fn.hover({
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
        }),

        '&:active': theme.activeStyles,
    },

    drawer: {
        backgroundColor: theme.colors.dark[6],
        color: theme.colors.dark[6]
    },

    dropdownFooter: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
        margin: `calc(${theme.spacing.md} * -1)`,
        marginTop: theme.spacing.sm,
        padding: `${theme.spacing.md} calc(${theme.spacing.md} * 2)`,
        paddingBottom: theme.spacing.xl,
        borderTop: `${rem(1)} solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1]
            }`,
    },

    collectionLink: {
        textDecoration: 'none',
        fontSize: theme.fontSizes.xs,
        color: theme.colors.dark[0],
        lineHeight: 1,
        fontWeight: 500,

        // '&:hover': {
        //     backgroundColor: theme.colors.dark[6],
        //     color: theme.white,
        // },
    },

    // The full menu needs about 940px, so use the burger menu below md (992px)
    // to leave room for wider fonts and browser zoom
    hiddenMobile: {
        [theme.fn.smallerThan('md')]: {
            display: 'none',
        },
    },

    hiddenDesktop: {
        [theme.fn.largerThan('md')]: {
            display: 'none',
        },
    },
}));

export const useUserButtonStyles = createStyles((theme) => ({
    user: {
      display: 'block',
      width: '100%',
      padding: theme.spacing.md,
      color: theme.colors.dark[0],
  
      '&:hover': {
        backgroundColor: theme.colors.dark[8],
      },
    },
  }));